
/*jshint esversion: 6 */
const state = {
  horses: [],
};

const mutations = {
  loadHorses(state, horses) {
    state.horses = horses;
  },
  deleteHorse(state, horseid) {
    const index = state.horses.findIndex(function (horse) {
      return horse.id === horseid;
    })
    if(index > -1) {
      state.horses.splice(index, 1);
    }
  },
  addNewHorse() {      
  },   
};

const getters = {
  horses: state => {
    return state.horses;
  },  
};

const actions = {
  loadHorses (context, { vm }) {

    const db = vm.$firebase.firestore();
    const horses = []
    db.collection("horses").onSnapshot(snapshot => {
      let changes = snapshot.docChanges();
      changes.forEach (change => {
        if (change.type == 'added') {
          horses.push({
            id: change.doc.id,
            name: change.doc.data().name,
            userid: change.doc.data().userid,
          });        
        }
      });  
      context.commit('loadHorses', horses);
      console.log("#loadHorses done#", new Date().getHours(), new Date().getMinutes(), new Date().getSeconds() );      
    }); 



  },  
  deleteHorse(context, props) {

    const db = props.vm.$firebase.firestore();
    state.message = '';
    state.showAlertAddHorse = false;
    db.collection('horses').doc(props.horseid).delete().then(() => {
      props.vm.$store.dispatch('writeLog',{userid: props.profile.id, username: props.profile.name , message: 'Horse deleted: ' + props.horseid, vm: props.vm});
      context.commit('deleteHorse', props.horseid);

    })
    .catch(err => {
      state.message = err.message;
      state.showAlertAddHorse = true;
    });
  },
  addNewHorse(context,props) {

    const db = props.vm.$firebase.firestore()
    let problem = false;
    state.message = '';
    state.showAlertAddHorse = false;    
    const horse = {
      name: props.newHorseName,
      userid: props.profile.id
    }

    if (props.newHorseName === '' ){
      state.message = "Vælg et navn til hesten";
      state.showAlertAddHorse = true;
      problem = true;
    }

    if (!problem){
      db.collection('horses').add(horse).then( (docRef) => {
        //console.log ('userid:' + props.profile.id + ', username: ' + props.profile.name)
        props.vm.$store.dispatch('writeLog',{userid: props.profile.id, username: props.profile.name , message: 'Horse added: ' + horse.name, vm: props.vm});
  
        horse.id = docRef.id;
        context.commit('addNewHorse', horse);
      })
      .catch(err => {
        state.message = err.message;
        state.showAlertAddHorse = true;
      });   
    } 
  }  
};  

  export default {
    state,
    mutations,
    actions,
    getters
  };